import { z } from 'zod'

export const formSchema = z.object({
  companyName: z.string().min(2, 'Company name is required'),
  firstName: z.string().min(2, 'First name is required'),
  lastName: z.string().min(2, 'Last name is required'),
  email: z.string().email('Please enter a valid email address'),
  projectSize: z.enum(['LT_50K', 'OPT50K_250K', 'OPT250K_500K', 'GT_500K'], {
    required_error: 'Project size is required',
  }),
  acceptTerms: z
    .union([z.string(), z.boolean()])
    .transform((value) => value === 'true' || value === true)
    .refine((val) => val === true, {
      message: 'You must agree to the terms and conditions',
    }),
})
